import { Component, OnInit } from '@angular/core';
declare var start_host;
@Component({
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss']
})
export class TimeoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  login(){
    window.location.href=start_host;
  }
}
